<template>
  <v-content>
    <v-overlay v-if="loadingOverlay === true">
      <div>Loading Page...</div>
    </v-overlay>
     <v-overlay v-if="refreshOverlay === true">
      <div>Fetching Lastest Ads...Reloading in 10 Seconds</div>
    </v-overlay>
    <v-container v-if="lead !== null">
      <h1 class="subheading grey--text">@{{lead.instagramProfile}}</h1>
      <v-card>
        <v-container>
          <v-row>
            <v-col cols="12" md="4">
              <div v-if="leadImage !== null" style="padding:10px;">
                <img :src="leadImage" contain @error="profileImageFail" />
              </div>
            </v-col>
            <v-col cols="12" md="8">
              <div v-if="typeof lead.instagramProfile !== 'undefined' ">
                <div v-if="lead.isInstagram === true">
                  <strong>Instagram Profile:</strong> &nbsp;
                  <a
                    :href="'https://instagram.com/'+ lead.instagramProfile"
                    target="_blank"
                  >https://instagram.com/{{lead.instagramProfile}}</a>
                </div>
                <div v-else>Facebook Ad</div>
              </div>

              <div v-if="typeof lead.profileDescription !== 'undefined'">
                <strong>Instagram Bio:</strong>
                <br />
                {{lead.profileDescription}}
              </div>
              <div v-if="typeof lead.profileDescription !== 'undefined'">
                <strong>Website:</strong>
                &nbsp;
                <a :href="lead.website" target="_blank">{{lead.website}}</a>
              </div>
              <div v-if="typeof lead.followers!== 'undefined'">
                <strong>Followers:</strong>
                {{lead.followers}}
              </div>
              <div v-if="typeof lead.engagementRate!== 'undefined'">
                <strong>Engagement Rate:</strong>
                {{ (lead.engagementRate * 100).toFixed(2) }}%
              </div>

              <div>
                <strong>Contacted:</strong>&nbsp;
                <span v-if="lead.contacted === true">YES</span>
                <span v-else>NO</span>
              </div>
              <div v-if="typeof lead.email!== 'undefined'">
                <strong>Email:</strong>
                {{ lead.email }}
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <h3>Ads from @{{lead.instagramProfile}}</h3>
      <v-card>
        <v-container>
          <v-row v-if="leadAds.length > 0">
            <v-col cols="12" md="4">
              <v-card v-for="ad in leadAds" :key="ad._id" class="mx-auto" max-width="400" outlined>
                <v-img
                  class="white--text"
                  height="200px"
                  :src="ad.imageUrl"
                  contain

                  @error="adImageFail"
                ></v-img>
                <v-card-actions>
                  <v-btn text color="green">
                    <a :href="'https://instagram.com/p/'+ad.shortcode" target="_blank">View Ad</a>
                  </v-btn>
                  <v-btn text color="green">
                    <a :href="ad.adLink" target="_blank">View Ad Landing Page</a>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </v-content>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import { leadLoadApi, leadAdsApi, adRefreshApi } from "@/config/appSettings";
export default {
  data: () => ({
    loadingOverlay: true,
    refreshOverlay: false,
    lead: null,
    leadAds: [],
    leadImage: null
  }),
  name: "LeadDetail",
  methods: {
    async loadLead() {
      let userToken = firebase.auth().currentUser.uid;
      let leadDetailUrl = `${leadLoadApi}${userToken}`;
      //console.log(this.$route.params.leadId)
      leadDetailUrl = `${leadDetailUrl}&id=${this.$route.params.leadId}`;
      //console.log(leadDetailUrl)
      try {
        let leadDetail = await axios.get(leadDetailUrl);

        if (leadDetail.data.success === true) {
          this.lead = leadDetail.data.result[0];
          // console.log("LEADS", this.lead);
          this.leadImage = this.lead.image;
          let leadAdUrl = `${leadAdsApi}${this.lead.instagramId}`;

          //console.log(this.$route.params.leadId)
          //console.log("LEAD AD URL: ", leadAdUrl);
          try {
            let leadAdList = await axios.get(leadAdUrl);
            //console.log("LEADS ADS", leadAdList);
            if (leadAdList.data.success === true) {
              this.leadAds = leadAdList.data.result;
              //console.log(this.leadAds);
            }
          } catch (err) {}
        }
      } catch (err) {}
    },
    async profileImageFail(event) {
      console.log(event);
    },
    async adImageFail(event) {
          

      //this.refreshOverlay = true 
      let refreshedAd = await axios.get(`${adRefreshApi}${encodeURIComponent(event)}`)
      this.reloadDelay()
    },
    closeLoadingModal() {
      let self = this;

      setTimeout(function() {
        self.loadingOverlay = false;
      }, 1000);
    },
    reloadDelay(){
      setTimeout(function() {
        location.reload();
      }, 5000);
    }
  },

  mounted() {
    this.loadLead();

    this.closeLoadingModal();
  }
};
</script>

<style scoped>
</style>